// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"3ea0f1de","129":"13e091c5","860":"fcf7ff20"}[chunkId] + ".chunk.js";
};